import {observer} from "mobx-react-lite";
import * as React from "react";
import {Ioc} from "../../models/ioc";
import {Link} from "react-router-dom";
import {Badge, Col, Row, Table} from "react-bootstrap";
import DateRow from "../DateRow";
import TargetRow from "../TargetRow";

const CheckLogsData = observer(function CheckLogsData(props: { data: Ioc[], totalFound: number, uniqueFound: number, truncated: number }) {
    const knownRecords = props.data.filter((v: Ioc) => v.active.length || v.history.length)

    return <>
        <Row>
            <Col>Active: <Badge variant="danger">{
                props.data
                    .map(v => v.active.length)
                    .reduce((acc, v) => v > 0 ? acc + 1 : acc, 0)
            }</Badge></Col>
            <Col>Known: <Badge variant="warning">{
                props.data
                    .map(v => v.active.length + v.history.length)
                    .reduce((acc, v) => v > 0 ? acc + 1 : acc, 0)
            }</Badge></Col>
            <Col>Unique: <Badge variant="info">{props.uniqueFound}</Badge></Col>
            <Col>Total: <Badge variant="secondary">{props.totalFound}</Badge></Col>
        </Row>
        <Table striped bordered className="logsTable">
            <thead>
            <tr>
                <th>IOC</th>
                <th>First Seen</th>
                <th>Last Seen</th>
                <th>Targets</th>
            </tr>
            </thead>
            <tbody>
            {knownRecords.length === 0 && <tr><td className="text-center" colSpan={4}>
                No malicious IP address or domain were found in {props.truncated ? <>first {props.truncated} records</> : <>submitted log</>}
            </td></tr>}
            {knownRecords.map((v: Ioc) => <tr className={v.active.length > 0 ? "" : "text-muted"}>
                    <td>
                        <Link to={"/check/" + v.ioc}>{v.ioc}</Link>
                    </td>
                    <td><DateRow timestamp={v.info.firstSeen} /></td>
                    <td>{v.active.length && v.info.lastSeen === v.active[0].last_used ? 'Now' : <DateRow timestamp={v.info.lastSeen} />}</td>
                    <td>{[...v.active, ...v.history]
                        .sort((a, b) => b.blocker.danger_level - a.blocker.danger_level)
                        .slice(0, 5)
                        .map(x => <TargetRow target={x.blocker} />)}
                    </td>
                </tr>)
            }
            </tbody>
        </Table>
    </>
})

export default CheckLogsData